// import Vue from 'vue';
// import mutations from './auth.mutationlist';

/* eslint no-param-reassign: [
  "error", { "props": true, "ignorePropertyModificationsFor": ["state"] }
] */
export default {
};



// WEBPACK FOOTER //
// ./src/store/auth/auth.mutations.js